export default {
  unit(state) {
    return state.unit
  },
  units(state) {
    return state.units
  },
  unitWindows(state) {
    return state.unitWindows
  },
  unitSchedules(state) {
    return state.unitSchedules
  },
  unitFilters(state) {
    return state.unitFilters
  },
  unitNeighbours(state) {
    return state.unitNeighbours
  },
  unitNeighboursLoad(state) {
    return state.unitNeighboursLoad
  },
  unitTypes(state) {
    return state.unitTypes
  },
  unitTypesFilter(state) {
    return state.unitTypesFilter
  },
  searchStores(state) {
    return state.searchStores
  },
}
